(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document && !root.FrostixMobileHeader) {
    root.FrostixMobileHeader = api.createController(root);
    root.FrostixMobileHeader.start();
    root.addEventListener('pagehide', () => root.FrostixMobileHeader.stop());
    root.addEventListener('pageshow', () => root.FrostixMobileHeader.start());
    root.document.addEventListener('shopify:section:load', () => root.FrostixMobileHeader.start());
    root.document.addEventListener('shopify:section:unload', event => {
      if (event.target.querySelector('.header-wrapper')) root.FrostixMobileHeader.stop();
    });
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function scrollState(previous, y, mobile, blocked) {
    y = Math.max(0, y);
    if (!previous || !mobile || blocked || y <= 0) return { y, travel: 0, hidden: false };
    const delta = y - previous.y;
    if (!delta) return previous;
    const travel = Math.sign(delta) === Math.sign(previous.travel) ? previous.travel + delta : delta;
    return { y, travel, hidden: travel >= 12 ? true : travel <= -8 ? false : previous.hidden };
  }

  function createController(root) {
    const document = root.document;
    const activeClass = 'mobile-header-autohide';
    const hiddenClass = 'mobile-header-hidden';
    const overlays = 'cart-drawer.active, cart-drawer[open], quick-add-modal[open], dialog[open], modal-dialog[open], .popup.active, .popup.open, .quick-view.active';
    let controller, header, main, collections, state, resizeObserver, mutationObserver;

    function syncHeight() {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }

    function measure() {
      if (!document.body.classList.contains(hiddenClass)) {
        document.body.style.setProperty('--mobile-header-reserve', header.offsetHeight + 'px');
        document.body.style.setProperty('--mobile-header-main-height', main.getBoundingClientRect().height + 'px');
        if (collections) document.body.style.setProperty('--mobile-header-collections-height', collections.getBoundingClientRect().height + 'px');
      }
      syncHeight();
    }

    function update() {
      const blocked = header.contains(document.activeElement) ||
        header.querySelector('details[open], [aria-controls][aria-expanded="true"]') || document.querySelector(overlays);
      state = scrollState(state, root.scrollY || 0, root.matchMedia('(max-width: 749px)').matches, blocked);
      document.body.classList.toggle(hiddenClass, state.hidden);
      syncHeight();
    }

    function resize() {
      document.body.classList.remove(activeClass, hiddenClass);
      state = scrollState(null, root.scrollY || 0, false, false);
      measure();
      document.body.classList.add(activeClass);
    }

    function start() {
      // Auswahl already owns this exact interaction, together with its page polish.
      // Never run two independent height/scroll controllers on that page.
      if (controller || document.querySelector('curated-selector')) return;
      header = document.querySelector('.section-header');
      main = document.querySelector('.header-wrapper > header.header');
      collections = document.querySelector('.header-wrapper > .header__collections-slider');
      if (!header || !main) return;
      controller = new root.AbortController();
      const options = { signal: controller.signal };
      state = scrollState(null, root.scrollY || 0, false, false);
      measure();
      document.body.classList.add(activeClass);
      root.addEventListener('scroll', update, { ...options, passive: true });
      root.addEventListener('resize', resize, options);
      document.addEventListener('focusin', update, options);
      document.addEventListener('focusout', update, options);
      mutationObserver = new root.MutationObserver(update);
      mutationObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'aria-expanded', 'class'] });
      if (root.ResizeObserver) {
        resizeObserver = new root.ResizeObserver(() => {
          const transitioning = [main, collections].some(node => node && node.getAnimations && node.getAnimations().some(animation => animation.playState === 'running'));
          if (!document.body.classList.contains(hiddenClass) && !transitioning) measure();
          else syncHeight();
        });
        resizeObserver.observe(header);
      }
    }

    function stop() {
      if (!controller) return;
      controller.abort(); controller = null;
      mutationObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      document.body.classList.remove(activeClass, hiddenClass);
      for (const name of ['--mobile-header-reserve', '--mobile-header-main-height', '--mobile-header-collections-height']) document.body.style.removeProperty(name);
      syncHeight();
    }

    return { start, stop };
  }
  return { scrollState, createController };
});
